import { apiFetch } from './apiFetch';

const updateGroup = async (id, method, payload) => {
  const url = `${process.env.REACT_APP_API_URL}/Site/${encodeURIComponent(id)}${method === 'PUT' ? '/name' : ''}`;
  const response = await apiFetch(url, {
    method,
    credentials: 'include',
    headers: { Accept: 'application/json', ...(payload ? { 'Content-Type': 'application/json' } : {}) },
    ...(payload ? { body: JSON.stringify(payload) } : {}),
  });
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error(body?.message || `HTTP ${response.status}`);
    error.status = response.status;
    error.body = body;
    throw error;
  }
  return body;
};

const siteService = {
  updateName: (id, siteName) => updateGroup(id, 'PUT', { siteName }),
  deleteGroup: (id) => updateGroup(id, 'DELETE'),
  get: async () => {
    const url = `${process.env.REACT_APP_API_URL}/Site`;

    try {
      const response = await apiFetch(url, {
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Parse JSON response instead of blob
      const result = await response.json();

      // Ensure response is an array or extract the correct field
      if (Array.isArray(result)) {
        return result;
      } else if (result && result.data && Array.isArray(result.data)) {
        return result.data;
      } else {
        throw new Error('Unexpected API response structure');
      }
      
    } catch (error) {
      console.error('Error fetching sites:', error);
      throw error; 
    }
  },

    create: async (payload) => {
    const url = `${process.env.REACT_APP_API_URL}/Site/CreateSiteMobile`;

    try {
      const response = await apiFetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const body = await response.json().catch(() => null);

      if (!response.ok) {
        const err = new Error(body?.message || `HTTP ${response.status}`);
        err.status = response.status;
        err.body = body; // 👈 allows modal to read errors[]
        throw err;
      }

      return body;
    } catch (error) {
      console.error('Error creating site:', error);
      throw error;
    }
  },
};

export default siteService;
